import { defineComponent as _defineComponent } from 'vue'
import { Offer } from '@/@types/graphql-types';
import NewDesignModal from '@/components/modals/NewDesignModal.vue';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { computed } from 'vue';
import DailyMotionPlayer from '@/ui-components/DailyMotionPlayer.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'JwTVModal',
  props: {
    offer: null,
    title: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { offer: Offer, title: TitleDetail };



const titleName = computed(() =>
	props.title?.__typename == 'Season' ? props.title?.show?.content.title : props.title?.content.title
);

const clip = computed(() => ({
	provider: 'JUSTWATCH_TV',
	externalId: props.offer.id,
	sourceUrl: props.offer.streamUrl as string,
}));

return { __sfc: true,props, titleName, clip, NewDesignModal, DailyMotionPlayer }
}

})